import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    feature: "Protocolo 'Manos Limpias' (10 min)",
    benefit: 'Reentrenar: contacto ≠ demanda'
  }, {
    feature: 'Mapa Verde/Amarillo/Rojo',
    benefit: 'Dejar de adivinar y dejar de evitarse'
  }, {
    feature: 'Guiones exactos para iniciar / pausar / decir no / decir sí',
    benefit: 'Reducir daño, vergüenza y peleas'
  }, {
    feature: 'Acuerdo de 60 segundos (antes) + Aftercare (después)',
    benefit: "Que el cuerpo recuerde 'fue seguro'"
  }, {
    feature: 'Plan de 14 días',
    benefit: 'Implementación realista para gente cansada'
  }];
  return <Section data-id="element-164">
      <h2 className="text-3xl md:text-4xl font-serif text-center text-[#2D2A26] mb-12" data-id="element-165">
        Lo que recibes
      </h2>

      <div className="bg-white rounded-sm shadow-lg overflow-hidden border border-stone-100" data-id="element-166">
        <div className="hidden md:grid grid-cols-2 bg-[#F0EBE0] p-4 font-serif font-semibold text-[#2D2A26]" data-id="element-167">
          <div data-id="element-168">Incluye</div>
          <div data-id="element-169">Para qué sirve</div>
        </div>

        <div className="divide-y divide-stone-100" data-id="element-170">
          {items.map((item, idx) => <div key={idx} className="grid grid-cols-1 md:grid-cols-2 p-6 gap-4 hover:bg-[#FAF7F2] transition-colors" data-id="element-171">
              <div className="font-medium text-[#2D2A26] flex items-start gap-3" data-id="element-172">
                <Check className="w-5 h-5 text-[#C4A35A] flex-shrink-0 mt-0.5 md:hidden" data-id="element-173" />
                {item.feature}
              </div>
              <div className="text-gray-600 flex items-start gap-3" data-id="element-174">
                <span className="text-[#C4A35A] md:hidden" data-id="element-175">→</span>
                {item.benefit}
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}